import { Box, Grid, Typography, Container } from "@mui/material";
// import LeaderDisplay from "../LeaderDisplay";
// import LeaderboardRankItem from "../../components/leaderboard/LeaderboardRankItem";
import SchoolLeaderboardRankItem from "./SchoolLeaderboardRankItem";

import leaderBoardBg_1 from "../../public/leaderBoardBg_1.png";
import leaderBoardBg_2 from "../../public/leaderBoardBg_2.png";
import leaderBoardBg_3 from "../../public/leaderBoardBg_3.png";
import leaderBoardBg_4 from "../../public/leaderBoardBg_4.png";


// import LeaderboardRankItem from "../LeaderboardRankItem";
import { useEffect } from "react";
// import { AdminApi } from "../../../api/AdminApi";
import { useState } from "react";
// import CoSportSchoolInfoCard from "../CoSportSchoolInfoCard";

// import CoSportSchoolInfoCard from "../components/leaderBoard/CoSportSchoolInfoCard/index.jsx";
// const MAIN_FONT = "Noto Sans TC";
import SchoolLeaderboardDisplay from "./SchoolLeaderboardDisplay";

import { Carousel } from "react-responsive-carousel";

const DefaultCarouselProps = {
    showThumbs: false,
    autoPlay: true,
    infiniteLoop: true,
    showIndicators: false,
    stopOnHover: false,
    showStatus: false,
    showArrows: false,
    // interval: 60000,
    interval: 4000,
    emulateTouch: true,
};

export default function SchoolLeaderboardSlideDisplay(
    {
        leaderboardList, filters,
        sliderSetting
    }
) {
    let caroselProps = DefaultCarouselProps;
    caroselProps.interval = sliderSetting?.interval || 4000;

    console.log("caroselProps: ", caroselProps);

    return (
        <Box>
            <Grid container direction="row" alignItems={"center"}>
                <Grid item xs={12}>
                    <Box>
                        <Carousel {...caroselProps}>
                            {leaderboardList.map((item, index) => (
                                <SchoolLeaderboardDisplay
                                    key={`school-leaderboard-slide-${index}`}
                                    leaderboardData={item}
                                    filters={filters} />
                            ))}
                        </Carousel>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}